import React, { useState } from 'react';
import { Button, Checkbox, Header, Icon, Label, List, Segment } from 'semantic-ui-react';
import FIELD_TYPE_OPTIONS from 'shared/constants/FIELD_TYPE_OPTIONS';
import { getOptionText } from '../constants';

const PipelineSummary = ({ title, pipeline }) => (
    <List.Item>
        <List.Icon name='filter' color='blue' />
        <List.Content>
            <List.Header>{title}: {pipeline.included ? pipeline.name : <i>Not included</i>}</List.Header>
            {pipeline.included && (
                <List.Description className='Onboarding__stage-chips'>
                    {pipeline.stages.map(({ id, name, days }, index) => (
                        <React.Fragment key={id}>
                            {index > 0 && <Icon name='angle right' />}
                            <Label basic size='small'>{name}<Label.Detail>{days}d</Label.Detail></Label>
                        </React.Fragment>
                    ))}
                </List.Description>
            )}
        </List.Content>
    </List.Item>
);

const ConfirmCrmSetup = ({ pipelines, fieldGroup, isApprovedInitially = false, onBack, onConfirm }) => {
    const [isApproved, setIsApproved] = useState(isApprovedInitially);
    const selectedFields = fieldGroup.fields.filter(({ selected }) => selected);
    const hasNoPipelines = !pipelines.lead.included && !pipelines.opportunity.included;

    return (
        <Segment>
            <Header as='h3'>
                Confirm Your CRM Setup
                <Header.Subheader>Saved as a draft. Pipelines and fields are created at launch.</Header.Subheader>
            </Header>
            <Header as='h4'>Pipelines</Header>
            {hasNoPipelines ? (
                <p>No pipelines added. DYL's default pipelines will be used, and you can change them in Settings → Pipeline.</p>
            ) : (
                <List relaxed>
                    <PipelineSummary title='Lead Pipeline' pipeline={pipelines.lead} />
                    <PipelineSummary title='Opportunity Pipeline' pipeline={pipelines.opportunity} />
                </List>
            )}
            <Header as='h4'>Contact Fields{selectedFields.length ? `: ${fieldGroup.name}` : ''}</Header>
            {selectedFields.length ? (
                <List divided relaxed>
                    {selectedFields.map(({ id, label, field_type, options }) => (
                        <List.Item key={id}>
                            <List.Icon name='list alternate outline' color='blue' />
                            <List.Content>
                                <List.Header>{label}</List.Header>
                                <List.Description>
                                    {getOptionText(FIELD_TYPE_OPTIONS, field_type)}{options.length && field_type === 'dropdown' ? `: ${options.join(', ')}` : ''}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                    ))}
                </List>
            ) : (
                <p>No custom fields. You can add them later in Settings → Data Customization.</p>
            )}
            <Segment secondary>
                <Checkbox
                    checked={isApproved}
                    onChange={(_, { checked }) => setIsApproved(checked)}
                    label="I've reviewed this CRM setup and approve it as my configuration draft"
                />
            </Segment>
            <Button basic type='button' onClick={onBack}><Icon name='arrow left' /> Back</Button>
            <Button primary floated='right' type='button' disabled={!isApproved} onClick={onConfirm}>
                Continue to Texting & Automation <Icon name='arrow right' />
            </Button>
            <div style={{ clear: 'both' }} />
        </Segment>
    );
}

export default ConfirmCrmSetup;
